module.exports = __webpack_public_path__ + "img/popup-close.24acdd3b.svg";